var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6675 0.628662L13.3838 4.18782C14.5687 8.09814 14.5687 13.902 13.3838 17.8125L14.6675 21.3713C18.9392 19.8608 22.0003 15.7889 22.0003 10.9997C22.0003 6.21132 18.9392 2.13923 14.6675 0.628662Z",
    fill: "#E61E25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6674 4.18769V0.628537C13.5202 0.222842 12.2863 0 11 0C12.6962 0 10.3443 5.74861 14.6674 4.18769Z",
    fill: "#F3F4F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 22.0001C12.2863 22.0001 13.5202 21.7772 14.6674 21.3715V17.8127C10.3878 17.3856 11 22.0001 11 22.0001Z",
    fill: "#F3F4F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.9998C0 15.805 3.08184 19.8876 7.37571 21.386V0.61438C3.08184 2.11273 0 6.19537 0 10.9998Z",
    fill: "#3757A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6676 17.8125V4.18769C13.9187 1.71548 12.6965 0 11.0002 0C9.72994 0 8.51118 0.218151 7.37598 0.614325V21.386C8.51118 21.7822 9.72994 22 11.0002 22C12.6965 22 13.9187 20.2845 14.6676 17.8125Z",
    fill: "#F3F4F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrance);
export default __webpack_public_path__ + "static/media/france.9a75beb61da8e0540bc78f9a47b4c1b3.svg";
export { ForwardRef as ReactComponent };